import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";
import { SvgIcon } from "../../components/SvgComponents";

interface IntroProps {
  headline: string;
  keywords: string[];
  introIcon?: string;
  frame: number;
  fps: number;
}

export const KineticTypeIntro: React.FC<IntroProps> = ({
  headline,
  keywords,
  introIcon,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const words = headline.split(" ");

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: "40px",
        padding: "0 40px",
      }}
    >
      {/* Icon Entrance */}
      <div
        style={{
          width: "240px",
          height: "240px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "rgba(190, 242, 100, 0.1)",
          border: "2px solid #BEF264",
          borderRadius: "40px",
          boxShadow: "0 0 30px rgba(190, 242, 100, 0.2)",
          transform: `scale(${spring({
            frame,
            fps,
            config: { stiffness: 200, damping: 12 },
          })}) rotate(${interpolate(frame, [0, 20], [-10, 0], {
            extrapolateRight: "clamp",
          })}deg)`,
        }}
      >
        <SvgIcon
          name={introIcon || "zap"}
          width={160}
          height={160}
          primaryColor="#BEF264"
        />
      </div>

      {/* Kinetic Headline */}
      <h1
        style={{
          fontFamily: "Outfit, sans-serif",
          fontSize: "64px",
          fontWeight: 900,
          color: "white",
          margin: 0,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "16px",
          lineHeight: 1.1,
          textTransform: "uppercase",
        }}
      >
        {words.map((word, i) => {
          const wordSpring = spring({
            frame: frame - 10 - i * 3,
            fps,
            config: { stiffness: 150, damping: 10, mass: 0.8 },
          });

          return (
            <span
              key={i}
              style={{
                display: "inline-block",
                transform: `scale(${wordSpring}) translateY(${(1 - wordSpring) * 20}px)`,
                opacity: wordSpring,
                color: i % 3 === 0 ? "#BEF264" : "white",
                textShadow: i % 3 === 0 ? "0 0 20px rgba(190, 242, 100, 0.5)" : "none",
              }}
            >
              {word}
            </span>
          );
        })}
      </h1>

      {/* Keywords Badge */}
      {keywords.length > 0 && (
        <div
          style={{
            display: "flex",
            gap: "12px",
            opacity: interpolate(frame, [30, 45], [0, 1], {
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp",
            }),
            transform: `translateY(${interpolate(frame, [30, 45], [20, 0], {
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp",
            })}px)`,
          }}
        >
          {keywords.slice(0, 3).map((kw, i) => (
            <span
              key={i}
              style={{
                padding: "8px 16px",
                background: "#22D3EE",
                color: "#050814",
                borderRadius: "10px",
                fontSize: "18px",
                fontWeight: 800,
                fontFamily: "Inter, sans-serif",
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              #{kw}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
